import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemStyle } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MyBranchIcon from "@NA/Icons/MyBranchIcon";
import { getWarehouseData } from "@NA/Services/ADIShopMyBranchService";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";


const defaultBranchInfo = {
    name: "",
    code: "",
    attributeid: "",
    address1: "",
    address2: "",
    phone: "",
    city: "",
    state: "",
    zipCode: "",
    fax: "",
    manager: "",
    hours: "",
    email: ""
}

const mapStateToProps = (state: CustomApplicationState) => {
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    return {
        isAuthenticated: state.context.session.isAuthenticated,
        isMylistAccess: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess || adiUserRoles.administrator,
    };
};

interface StateProps {
    isAuthenticated: boolean;
    isMylistAccess: boolean;
}

const ADIHPPMyBranch:React.FC<StateProps> = ({isAuthenticated, isMylistAccess}) => {
    const history = useHistory();
    const [branchInfo, setBranchInfo] = useState(defaultBranchInfo);

    interface ADIHPPMyBranchStyles {
        MyBranchGridContainer?: InjectableCss;
        MyBranchTimeContainer?: InjectableCss;
        MyBranchAddresSection?: InjectableCss;
        MyBranchSectionTitle?: InjectableCss;
        MyBranchHourSection?: InjectableCss;
        MyBranchContentSection?: InjectableCss;
        MyBranchManagerSection?: InjectableCss;
        innerTextStyle?: InjectableCss;
        innerHoursTextStyle?: InjectableCss;
        innerPhoneTextStyle: InjectableCss;
        innerEmailTextStyle?: InjectableCss;
        directions: InjectableCss;
        HPPMyBranch?: InjectableCss;
        contactNumberStyle?: InjectableCss;
        branchInfo?: InjectableCss;
        HPPGridContainer?: InjectableCss;
        myBranchGridContainer?: InjectableCss;
        HPPGridCard?: InjectableCss;
        HPPTwoColGridCard?: InjectableCss;
        HPPTitleCardContainer?: InjectableCss;
        HPPTitle?: InjectableCss;
        HPPContentCardContainer?: InjectableCss;
        HPPContentTitle?: InjectableCss;
        HPPContentDescription?: InjectableCss;
        HPPBtnStyle?: InjectableCss;
        HPPBtnGriditem?: InjectableCss;
        HPPTwoColBtnGriditem?: InjectableCss;
        HPPContentGridItem?: InjectableCss;
        myBranchContentGridItem?: InjectableCss;
        HPPTittleGridItem?: InjectableCss;
        HPPContentGridContainer?: InjectableCss;
    }

    const ADIHPPMyBranchStyles: ADIHPPMyBranchStyles = {
        myBranchGridContainer: {
            css: css`
                margin: 0 auto;
                padding: 15px 0;
                gap: 20px;
                display: flex;
                flex-direction: column;
                flex: 1;
                height: 100%;
                position: relative;
    
                ${({ theme }) =>
                    breakpointMediaQueries(theme, [
                        css`flex-direction: column;`,
                        css`flex-direction: column;`,
                        css`gap: 50px;`,
                        null,
                        null,
                    ])}
                    ${GridWrapper} {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                css`
                                    max-width:100%;
                                `,
                                null,
                                null,
                            ])}
                    } 
            `,
        },
        HPPGridCard: {
            css: css`
            flex:1;
            min-height:388px;
            border-radius: 6px;
            background-color: #fff;
            border-radius: 6px;
            border: solid 1px #bbb;
            ${({ theme }) =>
            breakpointMediaQueries(theme, [
                css`min-height:auto;`,
                css`min-height:auto;`,
                css`min-height:auto;`,
                null,
                null,
            ])}       
            > ${GridOffset} {
             width:100%;
             margin:0px;
             height: 100%;
            }
        `,
        },
        HPPTwoColGridCard: {
            css: css`
            flex:1;
            min-height:285px;
            border-radius: 6px;
            background-color: #fff;
            border-radius: 6px;
            border: solid 1px #bbb;
            ${({ theme }) =>
            breakpointMediaQueries(theme, [
                css`min-height:auto;`,
                css`min-height:auto;`,
                css`min-height:auto;`,
                null,
                null,
            ])}       
            > ${GridOffset} {
             width:100%;
             margin:0px;
             height: 100%;
            }
        `,
        },
        HPPTitleCardContainer: {
            css: css`
            border-radius: 6px;
            border-bottom-left-radius:0px;
            border-bottom-right-radius:0px;
            padding: 15px 20px !important;
            background-color: #006892;
            width:100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            > svg {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width:28px;
                            height:28px;
                        `,
                        css`
                            width:28px;
                            height:28px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
        },
        HPPTitle: {
            css: css`
            font-size: 20px;
            font-weight: bold;
            line-height: normal;
            color: #fff;
            margin-left:10px;
            ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        font-size: 16px;
                    `,
                        css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 18px;
                    `,
                        null,
                        null,
                    ])}
        `,
        },
        HPPContentCardContainer: {
            css: css`
            padding:15px 20px 20px;
            height:calc(100% - 65px);
            border-top-left-radius:0px;
            border-top-right-radius:0px;
            border-top:none;
            display: flex;
            flex-direction: column;
            justify-content:flex-start;
            align-items: flex-start;
            width: 100%;
            margin: 0 auto;
        `,
        },
        HPPContentGridContainer: {
            css: css`
            > ${GridOffset} {
             width:100%;
             margin:0px;
             height: 100%;
             display: flex;
            flex-direction: column;
                ${GridItemStyle}{
                    max-width: 100%;
                    width:100%;
                    padding: 0px;
                    flex-basis:initial;
                    flex-direction: column;
                }
            }   
        `,
        },
        HPPTittleGridItem: {
            css: css`
                   
        `,
        },
        HPPContentTitle: {
            css: css`
            font-size: 20px;
            font-weight: bold;
            line-height: normal;
            color: #2d2926;
            margin-bottom:10px;
            display: block;
            text-transform: capitalize;
             ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        font-size: 16px;
                    `,
                        css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 18px;
                    `,
                        null,
                        null,
                    ])}
        `,
        },
        HPPContentDescription: {
            css: css`
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            color: #2d2926;
            margin-bottom:10px;
            display: block;
        `,
        },
        myBranchContentGridItem : {
            css: css`
                display:flex;
                flex-direction:row;
                width: 100%;
                min-width: 100%;
                gap: 16px;
                margin-bottom: 20px;
                > div {
                    &:first-child {
                        max-width: 63%;
                        flex-basis: 63%;
                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                        css`
                            max-width: 63%;
                            flex-basis: 63%;
                        `,
                        css`
                            max-width: 76%;
                            flex-basis: 76%;
                        `,
                        css`
                            max-width: 63%;
                            flex-basis: 63%;
                            flex-direction: row;
                        `,
                        ])}
                    }
                    &:last-child {
                        flex: initial;
                        max-width: 33%;
                        flex-basis: 33%;
                        ${({ theme }) => { return breakpointMediaQueries(
                            theme, [css` max-width: 100%;flex-basis: 100%; `,],"max",); 
                         }}
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        flex-direction: column;
                    `,
                        css`
                        flex-direction: column;
                    `,
                        css`
                        justify-content: space-between;
                    `,
                        css`
                        gap: 120px;
                    `,
                        css`
                        gap: 30px;
                    `,
                    ])}
            `,
        },
        HPPBtnGriditem: {
            css: css`
            display: flex;
            width:100%;
        `,
        },
        HPPBtnStyle: {
            css: css`
            padding: 10px;
            border-radius: 4px;
            border: solid 1px #004da6;
            background-color: #fff;
            width: calc(100% - 40px);
            margin: 0 20px 20px;
            position: absolute;
            left: 0;
            bottom: 16px;

            ${({ theme }) => { return breakpointMediaQueries(
                theme, [null, null, 
                css` width: 100%; 
                     margin: 0;
                     bottom: 0;
                     position: relative;`
                ,],"max",); 
            }}

            &:hover {
                    background-color: #c8ddf6;
            }
            > span[class^="TypographyStyle"]  {
                color: #004da6;
                font-size: 16px;
                font-weight: bold;
                 ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        font-size: 14px;
                    `,
                        css`
                        font-size: 14px;
                    `,
                         css`
                        font-size: 14px;
                    `,
                        null,
                        null,
                    ])}
                
            }
        `,
        },
        HPPTwoColBtnGriditem: {
            css: css`
            display: flex;
            width:100%;
            button {
                left: auto;
                right: 0;
                max-width: 210px;
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [null, null, css` max-width: 100%; `,],"max",); 
                }}
            }
        `,
        },
        MyBranchGridContainer: {
            css: css`
                display:flex;
                flex-direction:row;
                width: 100%;
                min-width: 100%;
                gap: 16px;
                margin-bottom: 20px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        flex-direction: column;
                    `,
                        css`
                        flex-direction: column;
                    `,
                        css`
                        flex-direction: row;
                        flex-wrap: wrap;
                        gap: 75px;
                    `,
                        css`
                        flex-direction: row;
                        flex-wrap: wrap;
                        gap: 50px;
                    `,
                        css`
                        flex-direction: column;
                        flex-wrap: wrap;
                    `,
                    ])}
            `,
        },
        MyBranchTimeContainer: {
            css: css`
                display: flex;
                justify-content: space-between;
                gap: 12px;
                width: 100%;
                flex: 1;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        flex-direction: column;
                    `,
                        css`
                        flex-direction: row;
                    `,
                        css`
                        order: 2;gap: 50px;
                    `,
                        css`
                        order: 2;
                        gap: 50px;
                        width: 57%;flex: initial;
                    `,
                        css`
                        flex-direction: row;
                    `,
                    ])}

            `
        },
        MyBranchSectionTitle: {
            css: css`
            font-size: 14px;
            font-weight: bold;
            color: #2d2926;
             ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        font-size: 16px;
                    `,
                        css`
                        font-size: 16px;
                    `,
                        null,
                        null,
                        null,
                    ])}
        `,
        },
        MyBranchContentSection: {
            css: css`
                display: flex;
                flex-direction: column;
                flex: initial;
            `
        },
        MyBranchAddresSection: {
            css: css`
                display: flex;
                flex-direction: column;
                flex: 1;
                ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`flex: initial;`,
                ])}
            `
        },
        innerTextStyle: {
            css: css`
                font-size: 14px;
                color: #2d2926;
                line-height: normal;
                margin-bottom: 0;
                text-transform: capitalize;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 12px;
                        `,
                    ])}
            `
        },
        innerHoursTextStyle: {
            css: css`
                font-size: 14px;
                color: #2d2926;
                line-height: normal;
                margin-bottom: 0;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 12px;
                        `,
                    ])}
            `
        },
        innerPhoneTextStyle: {
            css: css`
                font-size: 14px;
                color: #2d2926;
                line-height: normal;
                margin-bottom: 0;                
                ${StyledButton}{
                    ${TypographyStyle}{
                        color: #2d2926;
                        text-decoration: underline;
                        &:hover {
                            color: #2d2926;
                        }
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 12px;
                        `,
                    ])}
            `
        },
        directions: {
            css: css`
                font-size: 14px;
                font-weight: bold;
                line-height: normal;
                color: #006ae3;
                margin-top: 5px;
                &${StyledButton} {
                    &:hover {
                        ${TypographyStyle}{
                            color: #006ae3;
                            text-decoration: underline;
                        }
                    }
                }   
            `
        },
        innerEmailTextStyle: {
            css: css`
                font-size: 14px;
                font-weight: bold;
                line-height: normal;
                color: #006ae3;
                margin-top: 5px;
                margin-bottom: 17px;
                padding-bottom: 10px;   
                ${StyledButton} {
                    &:hover {
                        ${TypographyStyle}{
                            color: #006ae3;
                            text-decoration: underline;
                        }
                    }
                }                
            `
        },
        MyBranchHourSection: {
            css: css`
                display: flex;
                flex-direction: column;
                flex:1;
                ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`max-width: 50%;`,
                ])} 
                    `
        },
        MyBranchManagerSection: {
            css: css`
                display: flex;
                flex-direction: column;
                flex:1;
                ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`flex: initial;`,
                ])}
            `
        },
        branchInfo: {
            css: css`
                margin-right: 4px;
           `         
         },
        contactNumberStyle: {
            css: css`
                font-weight: normal;
                text-decoration: underline;
                ${StyledButton}{
                    ${TypographyStyle}{
                        color: #000000;
                        text-decoration: underline;
                        &:hover {
                            color: #000000;
                        }
                    }
                }
            `
        }
    };
    const styles = ADIHPPMyBranchStyles;
    const loyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData.loyaltyRewardStore.loyalty);
    const userRoles = useSelector((state: CustomApplicationState) => state.context.session.userRoles);
    const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");

    useEffect(() => {
        fetchData();
    }, [isAuthenticated])

    const fetchData = async () => {
        const response = await getWarehouseData();
        setBranchInfo(response);
    }

    return (
        <>
        {isAuthenticated && 
        <StyledWrapper {...styles.myBranchGridContainer}>
         <GridContainer {...(!isMylistAccess && !isProRewardsUser ? styles.HPPTwoColGridCard : styles.HPPGridCard)}>
            <GridItem width={[12]} {...styles.HPPTitleCardContainer}>
                <MyBranchIcon/>
                <Typography {...styles.HPPTitle}>{translate("My Branch")}</Typography>
            </GridItem>
            <GridItem width={[12]} {...styles.HPPContentCardContainer}>
                <GridContainer {...styles.HPPContentGridContainer}>
                    <GridItem {...styles.HPPTittleGridItem}>
                         {branchInfo?.name && (
                        <Typography {...styles.HPPContentTitle}>{`${branchInfo.name.toLowerCase()} Branch`}</Typography>
                         )}
                        </GridItem>
                        <GridItem {...styles.HPPContentGridItem}>
                        <StyledWrapper {...(!isMylistAccess && !isProRewardsUser ? styles.myBranchContentGridItem : styles.MyBranchGridContainer)}>
                            <StyledWrapper {...styles.MyBranchTimeContainer}>
                                <StyledWrapper {...styles.MyBranchAddresSection}>
                                    <Typography {...styles.MyBranchSectionTitle}>{translate("Address")}</Typography>
                                    <Typography variant="p" {...styles.innerTextStyle}>{branchInfo?.address1?.trim().toLowerCase()}</Typography>
                                    <Typography variant="p" {...styles.innerTextStyle}>{branchInfo?.address2?.trim().toLowerCase()}</Typography>
                                    <Typography variant="p" {...styles.innerTextStyle}>{branchInfo?.city?.trim().toLowerCase()}, {branchInfo?.state?.trim()} {branchInfo?.zipCode?.trim()}</Typography>
                                    <Typography variant="p" {...styles.innerPhoneTextStyle}><Link href={translate(`tel:${branchInfo?.phone?.trim()}`)}>{branchInfo?.phone?.trim().replace(/\-/g, '.')}</Link></Typography>
                                    <Link
                                        {...styles.directions}
                                        style={{ fontWeight: "bold" }}
                                        href={`http://maps.google.com/maps?daddr=${branchInfo?.address1} ${branchInfo?.address2}, ${branchInfo?.city}, ${branchInfo?.state} ${branchInfo?.zipCode}`}
                                        target="_blank"
                                    >
                                        {translate("Directions")}
                                    </Link>
                                </StyledWrapper>
                                <StyledWrapper {...(!isMylistAccess && !isProRewardsUser ? styles.MyBranchContentSection : styles.MyBranchHourSection)}>
                                    <Typography {...styles.MyBranchSectionTitle}>{translate("Hours")}</Typography>
                                    <Typography variant="p" {...styles.innerHoursTextStyle}>
                                        {translate("Mon-Fri: 7:30 a.m. - 5:30 p.m.")}
                                    </Typography>
                                    <Typography variant="p" {...styles.innerHoursTextStyle}>
                                        {translate("May vary due to events or holidays.")}
                                    </Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                            <StyledWrapper {...styles.MyBranchManagerSection}>
                                <Typography {...styles.MyBranchSectionTitle}>{translate("Manager")}</Typography>
                                <Typography variant="p" {...styles.innerTextStyle}>
                                    {branchInfo && branchInfo.manager &&
                                    <Typography {...styles.branchInfo}>{branchInfo.manager}</Typography>
                                    }
                                    <Typography {...styles.contactNumberStyle}><Link href={translate(`tel:${branchInfo?.phone?.trim()}`)}>{branchInfo?.phone?.trim().replace(/\-/g, '.')}</Link></Typography>
                                </Typography>
                                <Typography variant="p" {...styles.innerEmailTextStyle}>
                                     {branchInfo?.email && (
                                    <Link href={`mailto:${branchInfo?.email}`}>{branchInfo?.email.charAt(0).toUpperCase() + branchInfo?.email.slice(1).toLowerCase()} </Link>
                                     )}
                                    </Typography>
                            </StyledWrapper>
                        </StyledWrapper >
                    </GridItem>
                    <GridItem {...(!isMylistAccess && !isProRewardsUser ? styles.HPPTwoColBtnGriditem : styles.HPPBtnGriditem)}>
                        <Button {...styles.HPPBtnStyle} onClick={() => history.push("/training-events")}>
                            {translate("Training and Events")}
                        </Button>
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
        </StyledWrapper>}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(ADIHPPMyBranch),
    definition: {
        group: "Basic",
        icon: "Banner",
        displayName: "ADI Mybranch Card",
        fieldDefinitions: [],
    },
};

export default widgetModule;
